
import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';
import { NullableMeasurement } from 'data/models/Measurement';
import { ExternalVesselSearchType } from 'server/enums/ExternalVesselSearchType';
import { VesselSearchResultData } from 'data/models/VesselSearchResult';
import { ExternalVesselSearch } from './model';

export const ExternalVesselSearchView = SuperCritical(({model} : { model : ExternalVesselSearch }) => {
    const results = model.SearchResults();
    return (
        <div className="search-service-vessel">
            <div className="service-search-vessel-filter">
                <div className="search-service-vessel-criteria">
                    <div className="service-vessel-search">
                        <input className="search-filter tt-input" type="text" value={model.Query()} onChange={e => model.Query(e.currentTarget.value)} placeholder="Select IMO or MMSI or Call Sign and enter the identifier" />
                    </div>
                    <div className="search-id-type">
                        <div hidden={!model.CanSearchImo()}>
                            <input name="searchTypeGroup" type="radio" 
                                checked={model.SearchType() === ExternalVesselSearchType.IMO} 
                                onChange={e => e.currentTarget.checked && model.SearchType(ExternalVesselSearchType.IMO)}/>IMO
                        </div>
                        <div hidden={!model.CanSearchMmsi()}>
                            <input name="searchTypeGroup" type="radio" 
                                checked={model.SearchType() === ExternalVesselSearchType.MMSI} 
                                onChange={e => e.currentTarget.checked && model.SearchType(ExternalVesselSearchType.MMSI)}/>MMSI
                        </div>
                        <div hidden={!model.CanSearchCallSign()}>
                            <input name="searchTypeGroup" type="radio" 
                                checked={model.SearchType() === ExternalVesselSearchType.CallSign} 
                                onChange={e => e.currentTarget.checked && model.SearchType(ExternalVesselSearchType.CallSign)}/>Call Sign
                        </div>
                    </div>
                    <div className="search-button">
                        <button type="button" className="pc-button" onClick={model.Search} disabled={!model.CanSearch() || model.Searching()}>
                            Search
                        </button>
                    </div>
                </div>
                <div className="import-menu">
                    <div className="manual-add-vessel">
                        <a href="" onClick={noDefault(model.ManualEnter)}>Manually enter a New Vessel</a>
                    </div>
                    <br/>
                    <div className="back-to-existing">
                        <a href="" onClick={noDefault(model.Cancel)}>Back to search</a>
                    </div>
                </div>
            </div>
            <div className="search-service-vessel-result">
            {results === null ? null :
             results.length === 0 ?
                <div className="no-results-found">
                    <span>No Results Found</span>
                </div> :
                <div className="search-results">
                    <table className="table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Service</th>
                                <th>Vessel Name</th>
                                <th>IMO</th>
                                <th>MMSI</th>
                                <th>VIN</th>
                                <th>Call Sign</th>
                                <th>Vessel Type</th>
                                <th>Draft</th>
                                <th>Length</th>
                            </tr>
                        </thead>
                        <tbody>
                            {results.map(v => 
                                <tr key={v.PSixServiceVesselId !== null ? 'psix-' + v.PSixServiceVesselId
                                            : v.LloydServiceVesselId !== null ? 'lloyds-' + v.LloydServiceVesselId
                                            : v.MarineTrafficServiceVesselId !== null ? 'marinetraffic-' + v.MarineTrafficServiceVesselId
                                            : ''}>
                                    <td><button type="button" className="pc-button" onClick={e => model.Select(v)}>Select</button></td>
                                    <td>{vesselServiceType(v)}</td>
                                    <td>{v.Name}</td>
                                    <td>{v.IMO}</td>
                                    <td>{v.MMSID}</td>
                                    <td>{v.VIN}</td>
                                    <td>{v.CallSign}</td>
                                    {/* Hiding vessel type for PSIX results b/c PSIX VesselType is so unreliable. */}
                                    <td>{v.PSixServiceVesselId ? '' : v.VesselType}</td>
                                    <td>{new NullableMeasurement(v.MaxDraft).toString()}</td>
                                    <td>{new NullableMeasurement(v.Length).toString()}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            }
        </div></div>
    );
});

function vesselServiceType(data : VesselSearchResultData) {
    return  data.VesselId                     ? "Local Vessel"   :
            data.MarineTrafficServiceVesselId ? "Marine Traffic" :
            data.PSixServiceVesselId          ? "PSix Vessel"    :
            data.LloydServiceVesselId         ? "LLoyds"         :
            "";
}


// WEBPACK FOOTER //
// ./apps/portcall/externalvesselsearch/view.tsx